/* globals Debug */
function Registration (
    Id,
    SuspendedActivity,
    TrackingEnabled,
    LessonMode,
    Package,
    Activities,
    GlobalObjectives,
    SSPBuckets,
    SharedData,
    LastSequenceNumber
) {
    this.Id = Id;
    this.SuspendedActivity = SuspendedActivity;
    this.TrackingEnabled = TrackingEnabled;
    this.LessonMode = LessonMode;
    this.Package = Package;
    this.Activities = Activities;
    this.GlobalObjectives = GlobalObjectives;
    this.SSPBuckets = SSPBuckets;
    this.SharedData = SharedData;
    this.LastSequenceNumber = LastSequenceNumber;
}

Registration.prototype = {
    FindActivityForThisScormObject: function (databaseId) {
        var i;

        for (i = 0; i < this.Activities.length; i += 1) {
            if (this.Activities[i].ScormObjectDatabaseId === databaseId) {
                return this.Activities[i];
            }
        }

        // eslint-disable-next-line new-cap
        Debug.AssertError("Registration_FindActivityForThisScormObject could not find the activity for learning object " + databaseId);

        return null;
    }
};
